module.exports = __webpack_public_path__ + "img/99.bdb2b0aa.png";